import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from 'helpers/theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SecondaryText, SecondaryTitle } from 'components/core/Typography';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    width: '100%',
    cursor: 'pointer'
  },
  containerActive: {
    extend: 'container',
    '&:hover $boxGraphic': {
      background: '#F6F7FA'
    }
  },
  boxGraphic: {
    width: '100%',
    border: '1px solid #EFF0F3',
    padding: 34,
    background: 'white',
    borderRadius: 9,
    marginBottom: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    alignItems: 'center',
    boxSizing: 'border-box'
  },
  boxSelected: {
    extend: 'boxGraphic',
    boxShadow: '0px 4px 4px #7b62df26',
    border: '2px solid #205BF5',
    boxSizing: 'border-box'
  },
  boxText: {
    fontSize: 15,
    fontWeight: 700,
    color: '#697184'
  }
}));

type Props = {
  selected?: boolean;
  icon: IconProp;
  boxText: string;
  title: string;
  subtitle: string;
  onClick: () => void;
  disabled?: boolean;
};

function SelectionBox(props: Props) {
  const classes = useStyles();

  const iconColor = props.selected ? '#205BF5' : '#697184';
  return (
    <div
      className={props.disabled ? classes.container : classes.containerActive}
      style={{ opacity: props.disabled ? 0.5 : 1 }}
      onClick={!props.disabled ? props.onClick : () => {}}
    >
      <div
        className={props.selected ? classes.boxSelected : classes.boxGraphic}
      >
        <FontAwesomeIcon
          icon={props.icon}
          color={iconColor}
          style={
            {
              '--fa-primary-color': iconColor,
              '--fa-secondary-color': iconColor,
              fontSize: '1.3rem'
            } as any
          }
        />
        <div className={classes.boxText} style={{ color: iconColor }}>
          {props.boxText}
        </div>
      </div>
      <SecondaryTitle>{props.title}</SecondaryTitle>
      <SecondaryText>{props.subtitle}</SecondaryText>
    </div>
  );
}

export default SelectionBox;
